module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('home')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.1@vue-loader/lib/template-compiler?{"id":"data-v-c5909bd8"}!./~/.12.2.1@vue-loader/lib/selector.js?type=template&index=0!./src/index/App.vue
// module id = 150
// module chunks = 4